import React from 'react';

import styles from '../title.module.scss';
import { ReactComponent as LawFirm } from '../../../../icons/entities/law-firm.svg';

export const LawFirmIcon = <LawFirm className={styles.icon} />;
